import { loadImages } from "./exterior";
import { getMainElement } from "./utils";

let initialized = false;

function setColorText(text) {
  const elText = document.getElementById("j360_exterior_color_text");
  if (elText) {
    elText.textContent = text.replace("-", " ");
  }
}

export default function initColors() {
  // only once
  if (initialized) {
    return;
  }

  initialized = true;

  const elMain = getMainElement();

  // listen change exterior color
  const colors = elMain.querySelectorAll("input[name=color]");
  colors.forEach((color) => {
    color.addEventListener("change", function () {
      if (this.checked) {
        const selectedValue = this.value;
        setColorText(selectedValue);

        loadImages(selectedValue);
      }
    });
  });
}
